import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import _ from 'lodash';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/FavoriteCompanies';

function* getFavoriteCompanies(action) {
    const endpoint = !_.isEmpty(action?.payload?.language)
        ? `/api/v1/user/company_favorite/?language=${action.payload.language}`
        : '/api/v1/user/company_favorite/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint,
                token: credential.data.token,
            },
        );
        yield put(Actions.getFavoriteCompaniesReceived(response));
    } catch (error) {
        yield put(Actions.getFavoriteCompaniesReceiveFailure(yield error));
    }
}

function* updateFavoriteCompanies(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/user/company_favorite/?language=${action.payload.language}`
        : '/api/v1/user/company_favorite/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.put, {
                endpoint,
                body: {
                    company_ids: action.payload?.language ? action.payload.companyIDs : action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.updateFavoriteCompaniesReceived(response));
    } catch (error) {
        yield put(Actions.updateFavoriteCompaniesReceiveFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeEvery('GET_FAVORITE_COMPANIES_REQUEST', getFavoriteCompanies),
        takeEvery('UPDATE_FAVORITE_COMPANIES_REQUEST', updateFavoriteCompanies),
    ]);
}
